import React from 'react';
import { useTranslation } from 'react-i18next';
import './SelectedNodeCartouche.css';

const SelectedNodeCartouche = ({ selectedNode, onClose }) => {
    const { t } = useTranslation();

    if (!selectedNode) return null;

    return (
        <div className="selected-node-floating-cartouche">
            <div className="selected-node-content">
                <span className={`node-type-${selectedNode.type || 'default'}`}></span>
                <div className="selected-node-text-floating">
                    <span className="selected-node-name-floating">{selectedNode.name}</span>
                    <div className="selected-node-details-floating">
                        <span className="selected-node-type-floating">{selectedNode.type}</span>
                        {selectedNode.technology && (
                            <span className="selected-node-tech-floating">{selectedNode.technology}</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectedNodeCartouche;